module.exports = __webpack_public_path__ + "img/IE.b968c78c.png";